import {
  DEVELOPMENT_CONSOLE_MODE,
  DEVELOPMENT_LEGACY_URL,
  STAGING_CONSOLE_MODE,
  STAGING_LEGACY_URL,
  PRODUCTION_CONSOLE_MODE,
  PRODUCTION_LEGACY_URL,
  IS_DEPLOYMENT_ENV_TEST,
  IS_DEPLOYMENT_ENV_STAGING,
  IS_DEPLOYMENT_ENV_PROD,
  CONSOLE_BASE,
} from "../../../envVariables";

export function getTargetHost() {
  if (IS_DEPLOYMENT_ENV_TEST) {
    if (DEVELOPMENT_CONSOLE_MODE === "legacy") {
      return CONSOLE_BASE;
    }
    return DEVELOPMENT_LEGACY_URL;
  }
  if (IS_DEPLOYMENT_ENV_STAGING) {
    if (STAGING_CONSOLE_MODE === "legacy") {
      return CONSOLE_BASE;
    }
    return STAGING_LEGACY_URL;
  }
  if (IS_DEPLOYMENT_ENV_PROD) {
    if (PRODUCTION_CONSOLE_MODE === "legacy") {
      return CONSOLE_BASE;
    }
    return PRODUCTION_LEGACY_URL;
  }
  return "";
}

export function getTargetUrl() {
  const targetHost = getTargetHost();
  return targetHost;
}
